import { render, staticRenderFns } from "./JobLists.vue?vue&type=template&id=05f1620e&scoped=true&"
import script from "./JobLists.vue?vue&type=script&lang=js&"
export * from "./JobLists.vue?vue&type=script&lang=js&"
import style0 from "./JobLists.vue?vue&type=style&index=0&id=05f1620e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f1620e",
  null
  
)

export default component.exports